import useCustomController from 'hooks/useCustomController';
import {useTranslation} from 'hooks/translations/useCustomTranslation';
import {useRouter} from 'next/router';
import React, {useEffect, useState} from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Slider} from '@mui/material';

import formatPrice from 'utils/formateHelpers/formatPrice';

import {palette} from 'styles/mui/scss';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from 'components/basic-components';

import styles from './styles/CarFilterSlider.module.scss';

const CarFilterSlider = ({title, inputName, minPrice, maxPrice}) => {
  const {t} = useTranslation('carFilter');
  const {locale} = useRouter();
  const {
    field: {onChange},
  } = useCustomController({name: inputName});
  const [price, setPrice] = useState([minPrice, maxPrice]);
  const changeHandler = (e, val) => {
    setPrice(val);
  };
  useEffect(() => {
    // onChange([minPrice, maxPrice]);
  }, [minPrice, maxPrice]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(price);
    }, 200);
    return () => clearTimeout(timeout);
  }, [price]);
  return (
    <Box>
      <Accordion defaultExpanded variant="mobile">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={styles.icon} />}
          aria-controls="panel2a-content"
        >
          <Typography className={styles.accordionTitle}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Box className={styles.sliderWrapper}>
              <Slider
                min={minPrice}
                max={maxPrice}
                sx={{
                  padding: '13px 0 !important',
                  '& .MuiSlider-track': {
                    border: 'none',
                  },
                  '& .MuiSlider-rail': {
                    backgroundColor: 'black',
                    opacity: '0.2',
                  },
                  '& .MuiSlider-thumb': {
                    width: '30px',
                    height: '30px',
                    border: `1px solid ${palette.colorBlack}`,
                    backgroundColor: palette.colorWhite,
                    '& .Mui-active': {
                      boxShadow: 'none',
                    },
                    '&:hover': {
                      boxShadow: 'none',
                    },
                    '&::after': {
                      width: '30px',
                      height: '30px',
                    },
                  },
                }}
                value={price}
                onChange={changeHandler}
              />
            </Box>
            <Box className={styles.priceWrapper}>
              <Box className={styles.priceTextWrapper}>
                <Typography className={styles.priceText}>{t('from')}</Typography>
                <Typography className={styles.priceAmount}>
                  {formatPrice(price[0], locale)} €
                </Typography>
              </Box>
              <Box className={styles.priceTextWrapper}>
                <Typography className={styles.priceText}>{t('to')}</Typography>
                <Typography className={styles.priceAmount}>
                  {formatPrice(price[1], locale)} €
                </Typography>
              </Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default CarFilterSlider;
